export const mainAPI = 'https://quaxo.cf/';